import {
  Event as EventIcon,
  Phone as CallIcon,
  Group as MeetingIcon,
  Email as EmailIcon,
} from '@material-ui/icons'

// No per-scheme event-type catalog exists on the API (EventOut.event_type is a free
// string). Hardcoded trio — same codes the Leads and Service EventItem.js dupes use.
export const EVENT_TYPES = [
  { code: 'meeting', name: 'Meeting', Icon: MeetingIcon },
  { code: 'call', name: 'Call', Icon: CallIcon },
  { code: 'email', name: 'Email', Icon: EmailIcon },
]

export const EVENT_TYPE_OPTIONS = EVENT_TYPES.map(t => ({ value: t.code, text: t.name }))

export const eventTypeLabel = (code) => EVENT_TYPES.find(t => t.code === code)?.name || code || 'Event'

export const eventTypeIcon = (code) => EVENT_TYPES.find(t => t.code === code)?.Icon || EventIcon
